module App.Interfaces {
    export interface IStorageBase {
        get<T>(key: string, defaultValue?: T): T;
        set<T>(key: string, value: T, params?: { [key: string]: string | number }): void;
    }
}